module.exports = __webpack_public_path__ + "static/media/NH.e6114d10.png";